import {createAction} from "@reduxjs/toolkit";

export const setRecurringEvents = createAction('SET_RECURRING_EVENTS');